import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";

import Rendertable from "./Rendertable";
import { getProductSearchResultforInactiveStock } from "../../../actions/productDetails";
import {
  getAllLocation,
  getAllLocationPlain,
} from "../../../actions/warehouseAction";
import { getAllCategory } from "../../../actions/categoryAction";
import { getAllTag } from "../../../actions/Inventory/tagAction";
import { getAllBrand } from "../../../actions/Inventory/brandAction";
import { getAllAttributeTerm , getAllAttribute  } from "../../../actions/attributeAction";

import {
  Divider,
  AutoComplete,
  Row,
  Col,
  Select,
  Skeleton,
  TreeSelect,
  Button,
  InputNumber,
  Checkbox
} from "antd";
const { Option } = Select;

const SearchStock = ({
  getProductSearchResultforInactiveStock,
  getAllLocation,
  getAllLocationPlain,
  categoryList,
  getAllCategory,
  getAllAttributeTerm,
  attributeTerms,
  getAllAttribute,
  attributes,
  getAllTag,
  getAllBrand,
  tags,
  brands,
}) => {
  const [List, setList] = useState([]);
  const [locations, setLocations] = useState([]);
  const [reload, setreload] = useState(false);
  const [loading, setloading] = useState(true);
  const location = useRef("");
  const keyward = useRef("");
  const pageno = useRef(1);
  const page_size = useRef(10);
  let total_data = useRef({});
  const searchCategory = useRef("");
  const searchAttribute = useRef("");
  const searchBrand = useRef("");
  const searchTag = useRef("");
  const lowrange = useRef("");
  const heighrange = useRef("");
  const zeroStock = useRef(false);

  const onChange = (event) => {
    if (event.keyCode == 13) {
      pageno.current = 1;
      keyward.current = event.target.value;
      setreload(true);
    }
  };
  const attributeTermTreeData = attributeTerms
    ? attributeTerms.map(term => ({
        title: term.name,
        value: term.id,
        key: term.id,
      }))
    : [];

    useEffect(() => {
      console.log("Attribute Terms:", attributeTerms);
    }, [attributeTerms]);
    

  useEffect(() => {
    getAllCategory();
    getAllAttributeTerm();
    getAllAttribute();
    getAllTag();
    getAllBrand();
    getAllLocationPlain().then((result) => {
      setLocations(result);
    });
    getProductSearchResultforInactiveStock(
      keyward.current,
      location.current,
      pageno.current,
      page_size.current,
      searchCategory.current,
      searchAttribute.current,
      lowrange.current,
      heighrange.current,
      zeroStock.current,
      searchBrand.current,
      searchTag.current
    ).then((result) => {
      total_data.current = {
        total_purchase_price: result.total_purchase_price,
        total_selling_price: result.total_selling_price,
        total_quantity: result.total_quantity,
        current_purchase_price: result.current_purchase_price,
        current_selling_price: result.current_selling_price,
        current_quantity: result.current_quantity,
      };
      setList(result);
      setloading(false);
    });
    setreload(false);
  }, [reload, pageno.current, page_size.current]);

  const attributeTreeData = attributes
  ? attributes.map(attr => ({
      title: attr.name,
      value: attr.id,
      key: attr.id,
      children: attr.terms.map(term => ({
        title: term.name,
        value: term.id,
        key: term.id,
      })),
    }))
  : [];

  const renderdata = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return (
        <Rendertable
          List={List}
          pageno={pageno}
          page_size={page_size}
          setreload={setreload}
          setloading={setloading}
          total_data={total_data}
        />
      );
    }
  };

  return (
    <>
      <Row>
        <Col span={5}>
          <h3>Barcode Search</h3>
          <AutoComplete
            placeholder="input search text"
            // onChange={onChange}
            onKeyUp={onChange}
            style={{ width: "100%" }}
          />
        </Col>
        <Col span={3} offset={1}>
          <h3>Location</h3>
          <Select
            placeholder="Please Select Location"
            style={{ width: "100%" }}
            onChange={(e) => {
              location.current = e;
              pageno.current = 1;
              setloading(true);
              setreload(true);
            }}
          >
            <Option value="">All</Option>
            {locations.map((outlet) => {
              return <Option value={outlet.id}>{outlet.name}</Option>;
            })}
          </Select>
        </Col>
        <Col span={3} offset={0}>
          <h3>Tag</h3>
          <Select
            placeholder="Select Tag"
            style={{ width: "100%" }}
            allowClear
            onChange={(value) => {
              pageno.current = 1;
              searchTag.current = value;
              setloading(true);
              setreload(!reload);
            }}
          >
            <Option value="">All</Option>
            {tags.map((tag) => (
              <Option key={tag.id} value={tag.id}>
                {tag.name}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={3} offset={0}>
          <h3>Brand</h3>
          <Select
            placeholder="Select Brand"
            style={{ width: "100%" }}
             allowClear
            optionFilterProp="children"
            showSearch
            filterOption={(input, option) =>
              ((option && option.children) ? option.children.toLowerCase() : '')
                .includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              ((optionA && optionA.children) ? optionA.children.toLowerCase() : '')
                .localeCompare(
                  (optionB && optionB.children) ? optionB.children.toLowerCase() : ''
                )
            }
            onChange={(value) => {
              pageno.current = 1;
              searchBrand.current = value;
              setloading(true);
              setreload(!reload);
            }}
          >
            <Option value="">All</Option>
            {brands.map((brand) => (
              <Option key={brand.id} value={brand.id}>
                {brand.name}
              </Option>
            ))}
          </Select>
        </Col>

        
        <Col span={3} offset={0}>
          <h3>Category</h3>

          <TreeSelect
            style={{ width: "100%" }}
            treeData={categoryList}
            onChange={(value) => {
              pageno.current = 1;
              searchCategory.current = value;
              setloading(true);
              setreload(!reload);
            }}
          />
        </Col>
        <Col span={3} offset={0}>
          <h3>Attribute</h3>
          <TreeSelect
            style={{ width: "100%" }}
            treeData={attributeTreeData}
            onChange={(value) => {
              pageno.current = 1;
              searchAttribute.current = value;
              setloading(true);
              setreload(!reload);
            }}
          />
        </Col>
        {/* <Col span={3} offset={0}>
          <h3>Min Price</h3>
          <InputNumber
            onKeyUp={(event) => {
              if (event.keyCode == 13) {
                pageno.current = 1;
                lowrange.current = event.target.value;
                setloading(true);
                setreload(!reload);
              }
            }}
          />
        </Col>
        <Col span={3}>
          <h3>Max Price</h3>
          <InputNumber
            onKeyUp={(event) => {
              if (event.keyCode == 13) {
                pageno.current = 1;
                heighrange.current = event.target.value;
                setloading(true);
                setreload(!reload);
              }
            }}
          />
        </Col> */}
        <Col span={2} offset={1}>
          <h3 style={{color:"white"}}>Zero Stock!</h3>
          <Checkbox
            onChange={(e) => {
              zeroStock.current = e.target.checked;
              pageno.current = 1;
              setloading(true);
              setreload(!reload);
            }}
          >
            All Stock
          </Checkbox>
        </Col>



        {/* <Col span={2} offset={1}>
        <h3>.</h3>
          <Button type="primary" style={{ width: "100%", marginRight: "4px" }} onClick={() => {
            setloading(true);
            setreload(!reload);
          }}>Search</Button>
        </Col> */}
        {/* <Col span={6} offset={1}></Col> */}
      </Row>

      <Divider />
      {renderdata()}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    // List: state.ProductDetails.productdetails,
    categoryList: state.category.categorylist,
    attributeTerms: state.attribute.attributeTerms,
    attributes: state.attribute.attributelist,
    tags: state.tag.taglist,
    brands: state.brand.brandlist,
  };
};

export default connect(mapStateToProps, {
  getProductSearchResultforInactiveStock,
  getAllLocation,
  getAllLocationPlain,
  getAllCategory,
  getAllAttributeTerm,
  getAllAttribute,
  getAllTag,
  getAllBrand,
})(SearchStock);
